import React, { ReactNode, type CSSProperties } from "react";
import { HiXMark } from "react-icons/hi2";
import classes from "./Alert.module.scss";
import cn from "classnames";
interface IAlert {
  children?: ReactNode;
  variant?: "primary" | "secondary" | "danger";
  icon?: ReactNode;
  isClose?: boolean;
  onClose?: () => void;
  style?: CSSProperties;
  childrenStyle?: CSSProperties;
  id?: string;
}
const Alert: React.FC<IAlert> = ({
  children = "",
  variant = "danger",
  icon,
  isClose,
  onClose,
  style,
  childrenStyle,
  id
}) => {
  return <div id={id} className={cn(classes.alert, cn(classes[variant]))} style={style} data-sentry-component="Alert" data-sentry-source-file="index.tsx">
      <div className={classes.alert_content}>
        <div>{icon}</div>
        <div style={childrenStyle}>{children}</div>
      </div>
      <div className={classes.alert_operation} onClick={onClose}>
        {isClose && <HiXMark />}
      </div>
    </div>;
};
export default Alert;